/**
 * @file
 * @fileOverview This file contains the AframeComponentManager class for the Aframe scene.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

import { lightComponents } from './AframeComponents/LightComponents.js';
import { ModelComponent } from './AframeComponents/ModelComponents.js';
import { NPC } from './AframeComponents/NPCcomponents.js';
import { UserInput } from './AframeComponents/UserInputComponents.js';
//import {shaders} from './AframeComponents/ShaderComponents.js';
import {debugComponents} from './AframeComponents/DebugComponents.js'
import {terrain} from './AframeComponents/TerrainComponents.js'
import { CameraComponent } from './AframeComponents/CameraComponents.js'
import { SoundComponent } from './AframeComponents/SoundComponents.js'
import { UtilComp } from './AframeComponents/UtilComponents.js';
import { EnhancedCameraComponent } from './AframeComponents/CameraProComponent.js';

  class ComponentManager {
    constructor() {
      this.components = {};
    }
  
    registerComponents(name, components) {
        if (!this.components[name]) {
          console.log('Components: ',components)
          Object.keys(components).forEach((componentName) => {

            if(this.isAFrameShader){
              this.components[componentName] = components[componentName];
              AFRAME.shaders[componentName] = components[componentName]; // Attach to global AFRAME object
              console.log(`Shader ${componentName} loaded from ${name}.`);
            }

            if(this.isAFrameComponent){
              this.components[componentName] = components[componentName];
              AFRAME.components[componentName] = components[componentName]; // Attach to global AFRAME object
              console.log(`Component ${componentName} loaded from ${name}.`);
            }
          });
        }
      }

      isAFrameShader(obj) {
        return (
          typeof obj === 'object' &&
          obj !== null &&
          typeof obj.schema !== 'undefined' &&
          (typeof obj.raw !== 'undefined' || 
           (typeof obj.vertexShader !== 'undefined' && 
            typeof obj.fragmentShader !== 'undefined'))
        );
      }

      isAFrameComponent(obj) {
        return (
          typeof obj === 'object' &&
          obj !== null &&
          typeof obj.init === 'function' &&
          typeof obj.update === 'function' &&
          typeof obj.schema !== 'undefined'
        );
      }

      registerShaders(name, shaders) {
        if (!this.shaders[name]) {
          console.log('Shaders: ', shaders);
          Object.keys(shaders).forEach((shaderName) => {
            this.shaders[shaderName] = shaders[shaderName];
            AFRAME.registerShader(shaderName, shaders[shaderName]); // Register shader with AFRAME
            console.log(`Shader ${shaderName} registered from ${name}.`);
          });
        }
      }
  
    /**
     * Load all components into the AFRAME object
     */
    loadComponents() {
      // Register components statically
      this.registerComponents('lightComponents', lightComponents);
      this.registerComponents('ModelComponent', ModelComponent);
      this.registerComponents('NPCcomponents', NPC);
      this.registerComponents('UserInputComponents', UserInput);
      this.registerComponents('terrainComponents', terrain);
     // this.registerComponents('ShaderComponents', shaders);
      this.registerComponents('debug',debugComponents); 
      this.registerComponents('CameraComponents', CameraComponent);
      this.registerComponents('SoundComponent',SoundComponent);
      this.registerComponents('UtilComponents',UtilComp);
      this.registerComponents('EnhancedCameraComponent',EnhancedCameraComponent);
      // Add more component groups as needed, using static imports
    }
  }
  
  export const componentManager = new ComponentManager();
  
  